// Similar-items templates for release overlay recommendation rows.
import { escapeHtml } from '../../utils/html'

type SimilarItemsTemplateInput = {
	sections: {
		id: string
		title: string
		items: {
			coverPlaceholderSrc: string
			coverSrc: string
			instanceId: number
			isHidden: boolean
			title: string
			year: string
		}[]
	}[]
}

/** Renders all similar item sections for a release overlay. */
export function releaseSimilarItemsTemplate({
	sections,
}: SimilarItemsTemplateInput): string {
	return sections
		.filter((section) => section.items.length > 0)
		.map(releaseSimilarItemsSectionTemplate)
		.join('')
}

/** Renders one horizontally scrollable similar item row. */
function releaseSimilarItemsSectionTemplate(
	section: SimilarItemsTemplateInput['sections'][number],
): string {
	return `
        <section class="release-similar-section" data-similar-section-id="${escapeHtml(section.id)}">
            <h2>${escapeHtml(section.title)}</h2>
            <div class="release-similar-row" role="list">
                ${section.items.map(releaseSimilarItemTemplate).join('')}
            </div>
        </section>
    `
}

/** Renders a single similar release card. */
function releaseSimilarItemTemplate(
	item: SimilarItemsTemplateInput['sections'][number]['items'][number],
): string {
	const hiddenClassName = item.isHidden ? ' is-hidden' : ''
	const yearHtml = item.year
		? `<span class="release-similar-year">${escapeHtml(item.year)}</span>`
		: ''

	return `
        <button
            type="button"
            class="release-similar-card${hiddenClassName}"
            data-similar-release-id="${item.instanceId}"
            role="listitem"
        >
            <img src="${escapeHtml(item.coverSrc)}" alt="" loading="lazy" decoding="async" draggable="false" onerror="this.src='${escapeHtml(item.coverPlaceholderSrc)}'">
            <p class="release-similar-title">${escapeHtml(item.title)}</p>
            ${yearHtml}
        </button>
    `
}
